<template> 
  <div v-if="formData.layout" class="text-left" :class="{submitting: submitting}" > 
    <h2>{{ formData.layout.title }}</h2> 
    <div v-if="!valid" class="text-danger mb-2">{{ message }}</div>
    <div v-if="!submitted">
      <dl class="emurse-form-fields" >
      <form-field-viewer ref="fields" v-for="field in formData.layout.fields" :field="field" :data="data"  :userProfile="userProfile" />  
      </dl>
      <button class="btn btn-primary" @click="submit" :disabled="submitting" >Submit</button>
    </div>
    <div v-else>
        {{message}}
    </div>
  </div>
</template>

  
<script lang="ts">
import { Inject, Options, Prop, Provide, Vue, Watch } from 'vue-property-decorator';  
import FormFieldViewer from './FormFieldViewer.vue';
import { UserProfile } from '@/data/repository/UserRepository';
import { FieldValidationResult } from './Forms';
import { FormRepository,SubmitFormRequest } from '@/data/repository/FormRepository';

@Options({components:{FormFieldViewer}})
export default class FormViewer extends Vue
{
    @Prop() public formData!: any; 
    @Inject() public formRepository!: FormRepository;
    @Inject() public recaptchaSiteKey!: string;

    public userProfile: UserProfile | null = null;
    public data!: any;

    public valid = true;
    public message = "";

    public submitted = false;
    public submitting = false;

    @Watch("formData")
    protected formDataChanged()
    {
      if (this.formData)
      {
        this.userProfile=this.formData.profile;
        this.data=this.formData.model;
      }
    }

    public submit()
    {
      this.validate();
    }

    public validateCaptcha()
    {
      const recaptcha = (window as any).grecaptcha;
      
      return new Promise<string>( (resolve,reject)=>{
        recaptcha.ready(()=>{
          recaptcha.execute(this.recaptchaSiteKey, {action: 'submit'}).then( (token: string) =>{
            resolve(token)
          }).catch(()=>{
            reject();
          })
        });
      }); 
    }

    public validate()
    {
      this.submitting = true;

      let fields = this.$refs.fields as any[];
      let results: FieldValidationResult[] =[]
      let error = false;
      let model: any = {};

      for (let i=0;i<fields.length;i++)
      {
        let view = (fields[i] as FormFieldViewer);
        let result= view.validate();
        results=results.concat(result);

       let modelValue: any = view.getModelValue(); 
       model =  {...model, ...modelValue };  

        for (let i=0;i<result.length;i++) {
          if (!result[i].valid) {
            error=true;
          }
        }
      } 

      if (!error) {

        let request = new SubmitFormRequest();
        request.formData=model;
        
        this.validateCaptcha().then(token =>{
          request.recaptchaToken = token;
          this.formRepository.submitForm(this.formData.id, request).then(r=>{
           this.valid = r.valid;
           this.message = r.message;

            if (r.valid)
            {
              this.submitted = true;
            }
            }).catch((error)=>{
              this.valid=false;
              this.message="Something went wrong trying to submit the form.";
              console.log("ERROR:" + error);
            }).finally(()=>{
              this.submitting = false;
            })
        }).catch(()=>{
          this.valid = false;
          this.submitting=false;
          this.message = "Failed to validate captcha.";
        });
      }
 
    }

    public mounted()
    {
      this.formDataChanged();
    }
}

</script>

<style lang="scss" >

.emurse-form-fields {
  dd {
    margin-bottom: 1rem;
  }
}

.submitting {
  opacity: .4;
}

</style>